import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlayCircle, MessageCircle, ArrowRight } from "lucide-react";

const Docs = () => {
  return (
    <section id="docs" className="py-24 bg-secondary/30">
      <div className="container px-6 mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            Resources & Documentation
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to get started and make the most of Upbrief.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          <Link to="/how-it-works" className="group">
            <div className="p-8 rounded-xl bg-card border border-border/50 hover:border-primary/50 hover:shadow-lg transition-all duration-300 h-full flex flex-col">
              <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <PlayCircle className="w-6 h-6" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">How It Works</h3>
              <p className="text-muted-foreground mb-4 flex-1">
                Step-by-step guide to creating templates, collecting updates, and generating reports.
              </p>
              <span className="text-primary text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                Learn more <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </Link>

          <div className="p-8 rounded-xl bg-card border border-border/50 h-full flex flex-col">
            <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
              <MessageCircle className="w-6 h-6" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">Questions?</h3>
            <p className="text-muted-foreground mb-4 flex-1">
              Reach out directly. Real answers, from the person who built it.
            </p>
            <a href="mailto:devinpurgason@gmail.com">
              <Button variant="outline" size="sm" className="w-fit">
                Email Devin
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Docs;
